import { useState } from 'react';
import { Popover } from '../../../../../../../common/components/Popover/Popover';
import { Help } from '../../../../../../../common/components/icons/Help';
import IconDollar from '../../../../../../../common/components/icons/IconDollar.svg';
import { PopUp } from '../../../../../../../common/components/popups/PopUp/PopUp';
import { useMobile } from '../../../../../../../common/services/screenSize/ScreenSizeService';
import {
  Icon,
  IconCircle,
  DentalPricingView,
  Value,
  HelpIconWrapper,
  StyledOkButton,
} from '../DentalPricing.styles';
import { DentalPricingGapFreeTooltip } from './DentalPricingGapFreeTooltip/DentalPricingGapFreeTooltip';

export const DentalPricingGapFree = () => {
  const [showingPopup, setShowing] = useState(false);
  const isMobile = useMobile();

  const handleHelpClick = () => {
    setShowing(true);
  };

  const handleClose = () => {
    setShowing(false);
  };

  const toolTip = <DentalPricingGapFreeTooltip />;

  const pricingText = 'Gap free check-up and clean available';

  return (
    <DentalPricingView>
      <IconCircle>
        <Icon as={IconDollar} aria-label="Pricing" />
      </IconCircle>

      <Value>
        {pricingText}

        {isMobile && (
          <>
            <HelpIconWrapper onClick={handleHelpClick}>
              <Help />
            </HelpIconWrapper>
            <PopUp showing={showingPopup} onClose={handleClose}>
              {toolTip}
              {isMobile && <StyledOkButton onClick={handleClose}>Ok</StyledOkButton>}
            </PopUp>
          </>
        )}
        {!isMobile && (
          <HelpIconWrapper>
            <Popover content={toolTip}>
              <Help />
            </Popover>
          </HelpIconWrapper>
        )}
      </Value>
    </DentalPricingView>
  );
};
